import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {connect} from "react-redux";
import {Link} from 'react-router-dom';
import {FormattedTime, FormattedDate, FormattedNumber} from 'react-intl';
import {Grid, Header, Table, Breadcrumb, Label, Button, Icon} from 'semantic-ui-react';
import {openPrinterSettingsModal} from "../../actions/PrinterSettingsModalAction";
import PrinterSettingsModal from "../../components/printer/PrinterSettingsModal";
import PrinterData from "../../data/PrinterData";
import CustomDivider from '../../components/extras/CustomDivider';
import DynamicTable from "../../components/extras/DynamicTable";
import CloseBoxData from "../../data/CloseBoxData";
import * as c from "../../constants";
import Loading from "../../components/extras/Loading";
import SimpleTable from "../../components/extras/SimpleTable";
import Auth from "../../data/auth";
import {showToast} from "../../actions/ToastAction";
let GLOBAL = require('../../data/globals');

class State extends Component{
    render(){
        let color
        let label

        if(this.props.state === 1){
            color = 'blue'
            label = 'Abierto'
        }
        else if(this.props.state === 2){
            color = 'orange'
            label = 'Anulado'
        }else{
            color = 'green'
            label = 'Pagado'
        }

        return <Label color={color} horizontal>
            {label} {this.props.statistic_total ? `: ${this.props.statistic_total}`:null}
        </Label>
    }
}

class BoxDetail extends Component {

    constructor(props) {
        super(props);
        
        let other_actions_product_sales =[
            this.buttonDownloadReportProductSales
        ]

        let other_actions_sales =[
            this.buttonDownloadReportSales
        ]

        this.state = {
            table_product_sales: {
                headers: ['Producto', 'Unidades Vendidas'],
                name: 'Producto',
                title: 'Productos Vendidos',
                pagination: true,
                url: `sales/open-box/products/${props.match.params.id}`,
                values: ['id', 'name', 'total'],
                id: 'box_detail_product_sales',
                other_actions_components: other_actions_product_sales
            },
            table_expenses: {
                headers: ['Fecha', 'Factura', 'Categoría', 'Valor'],
                name: 'Gasto',
                title: 'Gastos',
                pagination: true,
                url: `expenses/open-box/${props.match.params.id}`,
                values: ['id', 'date_creation', 'invoice_number', 'type_name', 'amount'],
                id: 'box_detail_expenses',
                datetime_fields: ['date_creation', ],
                money_fields: ['amount']
            },
            table_sales: {
                headers: ['Factura Nº', 'Fecha', 'Estado', 'Descuento', 'Impuesto', 'Total'],
                name: 'Ventas',
                title: 'Venta',
                pagination: true,
                url: `sales/open-box/${props.match.params.id}`,
                values: ['id', 'billing_number', 'date', 'state', 'discount', 'taxes', 'total'],
                id: 'box_detail_sales',
                datetime_fields: ['date', ],
                other_actions_components: other_actions_sales,
                money_fields: ['total', 'discount', 'taxes'],
                component_fields: [
                    {'state': State}
                ]
            },
            table_partial_box: {
                headers: ['Fecha', 'Valor'],
                title: 'Cierres Parciales',
                url: `partial-open-box-list/${props.match.params.id}`,
                values: ['id', 'amount', 'date'],
                money_fields: ['amount'],
                datetime_fields: ['date'],
                id: 'table_partial_boxes'
            },
            data: {
                branch_office: {id: '----', name: '----'},
                code: 0,
                count_sales: 0,
                expenses: 0,
                amount: 0,
                total_cancel_sales: 0,
                id: null,
                start_date: new Date().toString(),
                total_sales: 0,
                user: {full_name: '----', id: null},
                payment_types: []
            },
            cash: 0,
            code: this.props.match.params.code,
            loading: true,
            sending_print: false,
        };
    }
    

    componentWillMount(){
        CloseBoxData.get(this.props.match.params.id).then(data => {
            this.setState({data, loading:false});
        }).catch((error) => console.log(error));
    }

    handlePrint = () => {
        this.setState({sending_print: true});
        PrinterData.printBox(this.state.data, null).then((res) =>{
            this.props.showToast({message:res, type:'success'});
            this.setState({sending_print: false});
        }, err =>{
            if(err === 1){
                this.props.openPrinterSettingsModal({is_open:true});
            }else if(err === 2){
                this.props.showToast({message:'Tenemos un problema en el servidor', type:'error'});
            }
            this.setState({sending_print: false});
        })
    }

    downloadReportProductSales = () =>{
        this.setState({downloading:true});
        Auth.tokenUID().then(res => {
            if(res.token){
                let link =   document.createElement("a");
                link.download = 'download';
                link.href = `${GLOBAL.BASE_URL}api/reports/sale-products/excel?token=${res.token}&uid=${res.uid}&open_box=${this.props.match.params.id}`;
                link.click();
            }
        }).catch((error) => console.log(error))
            .finally(() => { this.setState({downloading:false}); });
    };

    downloadReportSales = () =>{
        this.setState({downloading:true});
        Auth.tokenUID().then(res => {
            if(res.token){
                let link =   document.createElement("a");
                link.download = 'download';
                link.href = `${GLOBAL.BASE_URL}api/reports/sales-by-open-box/excel?token=${res.token}&uid=${res.uid}&open_box=${this.props.match.params.id}`;
                link.click();
            }
        }).catch((error) => console.log(error))
            .finally(() => { this.setState({downloading:false}); });
    };

    buttonDownloadReportProductSales = () => {
        return <div style={{margin:6}}>
            <Button fluid content='Descargar Reporte' onClick={()=>this.downloadReportProductSales({})} icon='download'/>
        </div>;
    }

    buttonDownloadReportSales = () => {
        return <div style={{margin:6}}>
            <Button fluid content='Descargar Reporte' onClick={()=>this.downloadReportSales({})} icon='download'/>
        </div>;
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{`Bisttros - Cierres de Caja Nº  ${this.state.code}`}</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/sales'>Finanzas</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section as={Link} to='/sales/boxes'>Cierres de Caja</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>{`Nº ${this.state.code}`}</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Header textAlign='center' as='h1'>{`Cierre de Caja Nº ${this.state.code}`}</Header>
                {!this.state.loading ? <Grid stackable columns={1}>
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <Table>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign='right'>Fecha y Hora de Apertura</Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong><FormattedDate
                                                value={this.state.data.start_date}/> - <FormattedTime
                                                value={this.state.data.start_date}/></strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign='right'>Fecha y Hora de Cierre</Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            {this.state.data.is_open ? <Label color='orange'>Caja Abierta</Label>:<strong><FormattedDate
                                                value={this.state.data.end_date}/> - <FormattedTime
                                                value={this.state.data.end_date}/></strong>}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign='right'>Usuario</Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>{this.state.data.user.full_name}</strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign='right'>Sucursal</Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>{this.state.data.branch_office.name}</strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign='right'>Valor Apertura</Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>$<FormattedNumber value={this.state.data.amount}
                                                                      currency="USD" maximumFractionDigits={0}
                                                                      minimumFractionDigits={0}/></strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign='center'>Medios de Pago</Table.Cell>
                                        <Table.Cell>
                                            <Table basic>
                                                <Table.Body>
                                                    {this.state.data.payment_types.length > 0 ? this.state.data.payment_types.map((payment_type) => {
                                                        return <Table.Row key={payment_type.id}>
                                                            <Table.Cell textAlign='right'>{c.PAYMENT_TYPES.find(type => {return type.key === payment_type.id }).text}</Table.Cell>
                                                            <Table.Cell textAlign='left'>
                                                                <strong>$<FormattedNumber value={payment_type.total}
                                                                                          currency="USD" maximumFractionDigits={0}
                                                                                          minimumFractionDigits={0}/></strong>
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    }):<Table.Row><Table.Cell textAlign='center' colSpan={2}>No se han realizado pagos</Table.Cell></Table.Row>}
                                                </Table.Body>
                                            </Table>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign='center'>Estado de Ventas</Table.Cell>
                                        <Table.Cell>
                                            <Table basic>
                                                <Table.Body>
                                                    {this.state.data.statistics.map((statistic) => {
                                                        return <Table.Row key={statistic.state}>
                                                            <Table.Cell textAlign='left'>
                                                               <State {...statistic} statistic_total={statistic.total}/>
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    })}
                                                </Table.Body>
                                            </Table>
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Grid.Column>
                        <Grid.Column>
                            <Table>
                                <Table.Body>
                                    <Table.Row error>
                                        <Table.Cell textAlign='right'><strong>Gastos</strong></Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>$<FormattedNumber value={this.state.data.expenses}
                                                                      currency="USD" maximumFractionDigits={0}
                                                                      minimumFractionDigits={0}/></strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row error>
                                        <Table.Cell textAlign='right'><strong>Ventas Anuladas</strong></Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>$<FormattedNumber value={this.state.data.total_cancel_sales}
                                                                      currency="USD" maximumFractionDigits={0}
                                                                      minimumFractionDigits={0}/></strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row error>
                                        <Table.Cell textAlign='right'><strong>Descuentos</strong></Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>$<FormattedNumber value={this.state.data.discounts}
                                                                      currency="USD" maximumFractionDigits={0}
                                                                      minimumFractionDigits={0}/></strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row error>
                                        <Table.Cell textAlign='right'><strong>Impuestos</strong></Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>$<FormattedNumber value={this.state.data.taxes}
                                                                      currency="USD" maximumFractionDigits={0}
                                                                      minimumFractionDigits={0}/></strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign='right'><strong>Propinas</strong></Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>$<FormattedNumber value={this.state.data.tips}
                                                                      currency="USD" maximumFractionDigits={0}
                                                                      minimumFractionDigits={0}/></strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign='right'><strong>Cierres Parciales</strong></Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>$<FormattedNumber
                                                value={this.state.data.partial_open_box}
                                                currency="USD" maximumFractionDigits={0}
                                                minimumFractionDigits={0}/></strong>
                                        </Table.Cell>
                                    </Table.Row>
                                    {this.state.data.is_open ? <Table.Row>
                                        <Table.Cell textAlign='right'><strong>Total En Efectivo</strong></Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <strong>$<FormattedNumber
                                                value={(this.state.data.amount + this.state.cash) - (this.state.data.expenses + this.state.data.partial_open_box)}
                                                currency="USD" maximumFractionDigits={0}
                                                minimumFractionDigits={0}/></strong>
                                        </Table.Cell>
                                    </Table.Row>:null}
                                    {this.state.data.is_open ? <Table.Row positive>
                                        <Table.Cell textAlign='right'><h2>Total</h2></Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <h2>$<FormattedNumber
                                                value={(this.state.data.amount + this.state.data.total_sales) - (this.state.data.expenses)}
                                                currency="USD" maximumFractionDigits={0}
                                                minimumFractionDigits={0}/></h2>
                                        </Table.Cell>
                                    </Table.Row>:<Table.Row positive>
                                        <Table.Cell textAlign='right'><h2>Total Ventas</h2></Table.Cell>
                                        <Table.Cell textAlign='left'>
                                            <h2>$<FormattedNumber
                                                value={this.state.data.total_sales}
                                                currency="USD" maximumFractionDigits={0}
                                                minimumFractionDigits={0}/></h2>
                                        </Table.Cell>
                                    </Table.Row>}
                                    <Table.Row>
                                        <Table.Cell colSpan={2} textAlign='center'>
                                            <Button
                                                icon
                                                labelPosition='left'
                                                onClick={this.handlePrint}
                                                loading={this.state.sending_print}
                                                disabled={this.state.sending_print}
                                            >
                                                <Icon name='print' />
                                                Imprimir
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column style={{marginBottom:'3em'}}>
                            <SimpleTable {...this.state.table_partial_box} />
                        </Grid.Column>
                        <Grid.Column style={{marginBottom:'3em'}}>
                            <DynamicTable {...this.state.table_sales} />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column style={{marginBottom:'3em'}}>
                            <DynamicTable {...this.state.table_expenses} />
                        </Grid.Column>
                        <Grid.Column style={{marginBottom:'3em'}}>
                            <DynamicTable {...this.state.table_product_sales} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>:<Loading />}
                <PrinterSettingsModal />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        openPrinterSettingsModal(modal){
            dispatch(openPrinterSettingsModal(modal))
        },
        showToast(toast){
            dispatch(showToast(toast))
        },
    }
}

export default connect(
    null,
    mapDispatchToProps
)(BoxDetail)


// WEBPACK FOOTER //
// ./src/containers/sales/BoxDetail.js